import * as actionTypes from './authActionTypes';

type AuthUser = {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
};

export const setAuthUser = (authuser: AuthUser) => ({
    type: actionTypes.AUTH_SET_USER,
    payload: {
        id: authuser.id,
        email: authuser.email,
        firstName: authuser.firstName,
        lastName: authuser.lastName,
    },
});

export const authenticate = (token?: string) => ({
    type: actionTypes.AUTH_AUTHENTICATE,
    payload: token,
});

export const authenticateSuccess = (user: any) => ({
    type: actionTypes.AUTH_AUTHENTICATE_SUCCESS,
    payload: user,
});

export const authenticateFailed = (error: string) => ({
    type: actionTypes.AUTH_AUTHENTICATE_FAILED,
    error,
});

export const authenticateViaToken = () => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_TOKEN,
});

export const authenticateViaTokenFailed = () => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_TOKEN_FAILED,
});

export const authenticateViaTokenSuccess = (user: AuthUser) => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_TOKEN_SUCCESS,
    payload: user,
});

export const authenticateViaCookie = () => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_COOKIE,
});

export const authenticateViaCookieFailed = () => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_COOKIE_FAILED,
});

export const authenticateViaCookieSuccess = (user: AuthUser) => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_COOKIE_SUCCESS,
    payload: user,
});

export const authenticateViaLoginless = (vt?: string, llt?: string, scope?: string) => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS,
    payload: {
        vt: vt,
        llt: llt,
        scope: scope,
    },
});

export const authenticateViaLoginlessSuccess = (user: AuthUser, llt: string, scope: string) => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS_SUCCESS,
    payload: {
        user: user,
        llt: llt,
        scope: scope,
    },
});

export const authenticateViaLoginlessFailed = (error: string) => ({
    type: actionTypes.AUTH_AUTHENTICATE_VIA_LOGINLESS_FAILED,
    payload: error,
});

export const login = (email: string) => ({
    type: actionTypes.AUTH_LOGIN,
    payload: email,
});

export const loginSuccess = (message: string) => ({
    type: actionTypes.AUTH_LOGIN_SUCCESS,
    payload: message,
});

export const loginFailed = (message: string) => ({
    type: actionTypes.AUTH_LOGIN_FAILED,
    payload: message,
});

export const logout = (callback?: () => void) => ({
    type: actionTypes.AUTH_LOGOUT,
    callback,
});

export const logoutSuccess = () => ({
    type: actionTypes.AUTH_LOGOUT_SUCCESS,
});

export const logoutFailed = () => ({
    type: actionTypes.AUTH_LOGOUT_FAILED,
});
